import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="disclaimer-box">
          <h3 className="disclaimer-title">Important Notice</h3>
          <p className="disclaimer-text">
            All products sold by Reta 1 are supplied as a reference research for laboratory and in vitro research use only. 
            They are not pharmaceuticals, are not intended for human or veterinary consumption, and no dosing or administration 
            guidance is provided for use in or on human or animals.
          </p>
        </div>
        <div className="footer-bottom">
          <p className="copyright">© 2025 Reta 1. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;